import { render, staticRenderFns } from "./TalentDashboard.vue?vue&type=template&id=d019d8d6"
import script from "./TalentDashboard.vue?vue&type=script&lang=js"
export * from "./TalentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports